import { render, staticRenderFns } from "./learning-outcome-report.vue?vue&type=template&id=2374a31a&scoped=true&"
import script from "./learning-outcome-report.vue?vue&type=script&lang=js&"
export * from "./learning-outcome-report.vue?vue&type=script&lang=js&"
import style0 from "./learning-outcome-report.vue?vue&type=style&index=0&id=2374a31a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2374a31a",
  null
  
)

export default component.exports